export enum TransType {
    SAVE_TRANSACTION_TYPE = "SAVE_TRANSACTION_TYPE",
    SAVE_TRANSACTION_TYPE_SUCCESS = "SAVE_TRANSACTION_TYPE_SUCCESS",
    SAVE_TRANSACTION_TYPE_FAIL = "SAVE_TRANSACTION_TYPE_FAIL",
  
    GET_TRANS_TYPE_STRAT = "GET_TRANSACTION_TYPE_STRAT",
    GET_TRANS_TYPE_SUCCESS = "GET_TRANSACTION_TYPE_SUCCESS",
    GET_TRANS_TYPE_FAIL = "GET_TRANSACTION_TYPE_FAIL",
  }